import React, { useState, useEffect } from "react";
import {
  NavLink,
  Route,
  Switch,
  useRouteMatch,
  useLocation,
  useParams,
  useHistory,
} from "react-router-dom";
import { Container, Grid, Menu } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";

import _ from "lodash";
import cx from "classnames";

import { fetchAccount } from "actions/accounts";

import AccountManagement from "components/features/Account/Management";
import UserManagement from "components/features/User/Management";
import UserDetail from "components/features/User/Management/Detail";
import ReportGeneration from "components/features/Reports";
import Back from "components/ui/Buttons/BackButton";
import Collections from "components/features/Collections";

import styles from "./management.module.scss";
import IadbInteractive from "components/features/IadbInteraction";
import Cleverstory from "components/features/Cleverstory";
import AuditLogs from "components/features/AuditLogs";
import Seek from "components/features/Seek";
import DataSource from "components/features/Datasource";
import GenerateReports from "components/features/GenerateReports";
import Integrations from "components/features/Integrations";
import Assets from "components/features/Assets";

export default function AccountDetail() {
  let { path, url } = useRouteMatch();
  const dispatch = useDispatch();
  const history = useHistory();

  const location = useLocation();
  const params = useParams();

  const { id } = params;
  const { state } = location;

  const [selected, setSelected] = useState(null);
  const [goBackPath, setGoBackPath] = useState("/");

  const account = useSelector((state) => state.accounts.account);
  const fetchingAccount = useSelector(
    (state) => state.accounts.fetchingAccount
  );

  useEffect(() => {
    if (state && state.account) {
      setSelected(state.account);
    }
  }, [state]);

  useEffect(() => {
    if (!fetchingAccount.fetching) {
      setSelected(account);
    }
  }, [account]);

  useEffect(() => {
    if (!fetchingAccount.fetching && id) {
      dispatch(fetchAccount({ id }))
    }
  }, []);

  return (
    <>
      <Switch>
        <Route path={path}>
          <Container className={cx(styles.container)}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4} className={cx(styles.pr_0)}>
                  <Container className={cx(styles.sidebar)}>
                    <Back path={goBackPath} />
                    <Menu text vertical className={styles.sideMenu}>
                      <Menu.Item
                        name="Account Management"
                        as={NavLink}
                        to={`${url}/management`}
                        className={cx(styles.menuItem)}
                        activeClassName={cx(styles.active)}
                      />

                      <Menu.Item
                        name="User Management"
                        as={NavLink}
                        to={`${url}/user_management`}
                        className={cx(styles.menuItem)}
                        activeClassName={cx(styles.active)}
                      />

                      {params.product !== "cleverstory" && (
                        <Menu.Item
                          name="Collections"
                          as={NavLink}
                          to={`${url}/Collections`}
                          className={cx(styles.menuItem)}
                          activeClassName={cx(styles.active)}
                        />
                      )}

                      {params.product !== "cleverstory" && (
                        <Menu.Item
                          name="Assets"
                          as={NavLink}
                          to={`${url}/Assets`}
                          className={cx(styles.menuItem)}
                          activeClassName={cx(styles.active)}
                        />
                      )}

                      {params.product !== "cleverstory" && (
                        <Menu.Item
                          name="Datasource"
                          as={NavLink}
                          to={`${url}/datasource`}
                          className={cx(styles.menuItem)}
                          activeClassName={cx(styles.active)}
                        />
                      )}

                      {
                        id == "5d3ae1e2c9e77c00013aa5cd" && (
                          <Menu.Item
                            name="IADB Interactive Content"
                            as={NavLink}
                            to={`${url}/iadb_interactive_content`}
                            className={cx(styles.menuItem)}
                            activeClassName={cx(styles.active)}
                          />
                        )
                      }
                      <Menu.Item
                        name="Integrations"
                        as={NavLink}
                        to={`${url}/integrations`}
                        className={cx(styles.menuItem)}
                        activeClassName={cx(styles.active)}
                      />
                      <Menu.Item
                        name="Cleverstory"
                        as={NavLink}
                        to={`${url}/cleverstory`}
                        className={cx(styles.menuItem)}
                        activeClassName={cx(styles.active)}
                      />

                      <Menu.Item
                        name="Audit Logs"
                        as={NavLink}
                        to={`${url}/audit_logs`}
                        className={cx(styles.menuItem)}
                        activeClassName={cx(styles.active)}
                      />
                      <Menu.Item
                        name="Seek"
                        as={NavLink}
                        to={`${url}/seek`}
                        className={cx(styles.menuItem)}
                        activeClassName={cx(styles.active)}
                      />
                      <Menu.Item
                        name="Reports"
                        as={NavLink}
                        to={`${url}/generate_report`}
                        className={cx(styles.menuItem)}
                        activeClassName={cx(styles.active)}
                      />
                    </Menu>

                  </Container>
                </Grid.Column>
                <Grid.Column width={12} className={cx(styles.pl_0)}>
                  <Container className={cx(styles.detail)}>
                    <Switch>
                      <Route
                        exact
                        path={`${path}/management`}
                        render={(props) => (
                          <AccountManagement account={selected} {...props} />
                        )}
                      />

                      <Route
                        exact
                        path={`${path}/user_management`}
                        render={(props) => (
                          <UserManagement
                            setGoBackPath={setGoBackPath}
                            account={selected}
                            {...props}
                          />
                        )}
                      />

                      <Route
                        path={`${path}/user_management/:userId`}
                        render={(props) => (
                          <UserDetail
                            setGoBackPath={setGoBackPath}
                            {...props}
                          />
                        )}
                      />

                      <Route
                        exact
                        path={`${path}/Collections`}
                        render={(props) => (
                          <Collections
                            setGoBackPath={setGoBackPath}
                            account={selected}
                            {...props}
                          />
                        )}
                      />

                      <Route
                        exact
                        path={`${path}/Assets`}
                        render={(props) => (
                          <Assets
                            account={selected}
                            {...props}
                          />
                        )}
                      />

                      {/* <Route
                        exact
                        path={`${path}/datasource_transactions`}
                        render= {(props) => (
                          <DataSourceTransactions
                            setGoBackPath={setGoBackPath}
                            account={selected}
                            {...props}
                            />
                        )}
                        /> */}

                      <Route
                        exact
                        path={`${path}/datasource`}
                        render={(props) => (
                          <DataSource
                            setGoBackPath={setGoBackPath}
                            account={selected}
                            {...props}
                          />
                        )}
                      />

                      <Route
                        exact
                        path={`${path}/reports`}
                        render={(props) => (
                          <ReportGeneration
                            setGoBackPath={setGoBackPath}
                            account={selected}
                            {...props}
                          />
                        )}
                      />

                      <Route
                        exact
                        path={`${path}/iadb_interactive_content`}
                        render={(props) => (
                          <IadbInteractive
                            setGoBackPath={setGoBackPath}
                            account={selected}
                            {...props}
                          />
                        )}
                      />

                      <Route
                        exact
                        path={`${path}/cleverstory`}
                        render={(props) => (
                          <Cleverstory
                            setGoBackPath={setGoBackPath}
                            account={selected}
                            isWorkspace={true}
                            isDomain={false}
                            {...props}
                          />
                        )}
                      />
                      <Route
                        exact
                        path={`${path}/cleverstory/:id`}
                        render={(props) => (
                          <Cleverstory
                            setGoBackPath={setGoBackPath}
                            account={selected}
                            workspace={state.workspaceId}
                            isWorkspace={false}
                            isDomain={true}
                            {...props}
                          />
                        )}
                      />

                      <Route
                        exact
                        path={`${path}/audit_logs`}
                        render={(props) => (
                          <AuditLogs
                            setGoBackPath={setGoBackPath}
                            account={selected}
                            {...props}
                          />
                        )}
                      />
                      <Route
                        exact
                        path={`${path}/seek`}
                        render={(props) => (
                          <Seek
                            setGoBackPath={setGoBackPath}
                            account={selected}
                            {...props}
                          />
                        )}
                      />
                      <Route
                        exact
                        path={`${path}/generate_report`}
                        render={(props) => (
                          <GenerateReports
                            setGoBackPath={setGoBackPath}
                            account={selected}
                            {...props}
                          />
                        )}
                      />
                      <Route
                        exact
                        path={`${path}/integrations`}
                        render={(props) => (
                          <Integrations
                            setGoBackPath={setGoBackPath}
                            account={selected}
                            {...props}
                          />
                        )}
                      />
                    </Switch>
                  </Container>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Route>
      </Switch>
    </>
  );
}